import { act, useEffect, useRef, useState } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { API_URL } from "../../utils/constant";
import { Eye } from "lucide-react";
import { Link } from "react-router-dom";
import DateWisePurchaseReportTable from "./report_other/dateWisePurchase";
import MonthWisePurchaseReportTable from "./report_other/monthWisePurchase";
import PartyWisePurchaseReportTable from "./report_other/partyWisePurchase";
import DateWiseSalesReportTable from "./report_other/dateWiseSales";
import MonthWiseSalesReportTable from "./report_other/monthWiseSales";
import { exportTableToExcel, exportToExcel } from "./report_other/export_excel";
import CompanyExpensesReport from "./report_other/companyExpenses";
import PaymentWiseReportTableData from "./report_other/paymentWise";




const OtherReports = () => {
    const [activeTab, setActiveTab] = useState("date");
    const [exportDateWise, setExportDateWise] = useState(null);
    const currentMonth = moment().month() + 1;
    const currentYear = moment().year();

    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedYear, setSelectedYear] = useState(currentYear);

    const [loading, setLoading] = useState(false);

    const today = moment().format("YYYY-MM-DD");
    const firstDay = moment().startOf("month").format("YYYY-MM-DD");

    const [startDate, setStartDate] = useState(firstDay);
    const [endDate, setEndDate] = useState(today);

    const [productTypePaymentSales, setProductTypePaymentSales] = useState('All');
    const [productTypeSalesMonthly, setProductTypeSalesMonthly] = useState('All');
    const [productTypeSales, setProductTypeSales] = useState('All');
    const [startDateSales, setStartDateSales] = useState(firstDay);
    const [endDateSales, setEndDateSales] = useState(today);

    const [startDatePaymentSales, setStartDatePaymentSales] = useState(firstDay);
    const [endDatePaymentSales, setEndDatePaymentSales] = useState(today);

    const [startDateParty, setStartDateParty] = useState(firstDay);
    const [endDateParty, setEndDateParty] = useState(today);

    const [startDateExpense, setStartDateExpense] = useState(firstDay);
    const [endDateExpense, setEndDateExpense] = useState(today);

    // Separate states for both tables
    const [dateWiseData, setDateWiseData] = useState([]);
    const [monthWiseData, setMonthWiseData] = useState([]);
    const [partyWiseData, setPartyWiseData] = useState([]);
    const [salesWiseData, setSalesWiseData] = useState([]);
    const [salesPaymentWiseData, setPaymentSalesWiseData] = useState([]);
    const [salesPaymentSummary, setPaymentSalesSummary] = useState([]);
    const [companyExpenseData, setCompanyExpenseData] = useState([]);
    const [salesWiseYearlyData, setSalesWiseYearlyData] = useState([]);

    const API_URL_PURCHASE = `${API_URL}/purchases/puchase-report/data`;
    const exportRef = useRef(null);

    const number_format = (number, decimals = 2) => {
        const n = Number(number);
        return n.toLocaleString("en-IN", {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });
    };



    const companyID = localStorage.getItem('companyID') || JSON.parse(localStorage.getItem('company') || '{}')?.company?.id || 4;

    // ----------------------------
    // Fetch for DATE WISE (daily)
    // ----------------------------
    const fetchMonthData = async () => {
        setLoading(true);
        try {
            const { data } = await axios.post(API_URL_PURCHASE, {
                company_id: companyID,
                type: "month",
                start_date: startDate,
                end_date: endDate,
            });
            setDateWiseData(data.data || []);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    // ----------------------------
    // Fetch for YEAR WISE (month-wise summary)
    // ----------------------------
    const fetchYearData = async () => {
        setLoading(true);
        try {
            const { data } = await axios.post(API_URL_PURCHASE, {
                company_id: companyID,
                type: "yearly",
                year: selectedYear,
            });
            setMonthWiseData(data.data || []);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const fetchPartyData = async () => {
        setLoading(true);
        try {
            const { data } = await axios.post(API_URL_PURCHASE, {
                company_id: companyID,
                type: "vendor",
                start_date: startDateParty,
                end_date: endDateParty
            });
            setPartyWiseData(data.data || []);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };


    const fetchSalesData = async () => {
        setLoading(true);
        try {
            const { data } = await axios.post(API_URL_PURCHASE, {
                company_id: companyID,
                type: "sales",
                product_type: productTypeSales,
                start_date: startDateSales,
                end_date: endDateSales
            });
            setSalesWiseData(data.data || []);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const fetchPaymentWiseSalesReport = async () => {
        setLoading(true);
        try {
            const { data } = await axios.post(API_URL_PURCHASE, {
                company_id: companyID,
                type: "sales_report",
                product_type: productTypePaymentSales,
                start_date: startDatePaymentSales,
                end_date: endDatePaymentSales
            });
            setPaymentSalesSummary(data.summary || []);
            setPaymentSalesWiseData(data.data || []);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const fetchCompanyExpenseData = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get(`${API_URL}/company-expenses/expenses/report?company_id=${companyID}&start_date=${startDateExpense}&end_date=${endDateExpense}`);
            console.log(data);
            setCompanyExpenseData(data || []);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };


    const fetchSalesYearlyData = async () => {
        setLoading(true);
        try {
            const { data } = await axios.post(API_URL_PURCHASE, {
                company_id: companyID,
                type: "month_sales",
                product_type: productTypeSalesMonthly,
                year: selectedYear,
            });
            setSalesWiseYearlyData(data.data || []);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    // Auto fetch when tab or filters change
    useEffect(() => {
        if (activeTab === "date") fetchMonthData();
        if (activeTab === "month_purchase") fetchYearData();
        if (activeTab === 'party_purchase') fetchPartyData();
        if (activeTab === 'sales') fetchSalesData();
        if (activeTab === 'month_sales') fetchSalesYearlyData();
        if (activeTab === 'expenses') fetchCompanyExpenseData();
        if (activeTab === 'sales_report') fetchPaymentWiseSalesReport();
    }, [activeTab, selectedMonth, selectedYear, productTypeSalesMonthly]);

    // ----------------------------
    // Month & Year Navigation
    // ----------------------------
    const handlePrevMonth = () => {
        setSelectedMonth((prev) => (prev === 1 ? 12 : prev - 1));
    };

    const handleNextMonth = () => {
        if (selectedMonth < currentMonth) {
            setSelectedMonth((prev) => prev + 1);
        }
    };

    const handlePrevYear = () => {
        setSelectedYear((prev) => prev - 1);
    };

    const handleNextYear = () => {
        if (selectedYear < currentYear) {
            setSelectedYear((prev) => prev + 1);
        }
    };





    // Datatable custom style
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#0251a6ff",
                color: "white",
                fontWeight: "bold",
                fontSize: "15px",
            },
        },
        rows: {
            style: {
                minHeight: "48px",
            },
        },
    };

    return (
        <div>
            <ul className="nav nav-pills mb-3 nav-justified tab-style-5 d-sm-flex d-block" role="tablist">
                {[
                    { key: "date", label: "Date Wise Purchases" },
                    { key: "month_purchase", label: "Month Wise Purchases" },
                    { key: "party_purchase", label: "Party Wise Purchases" },
                    { key: "sales", label: "Date Wise Sales" },
                    { key: "month_sales", label: "Month Wise Sales" },
                    { key: "sales_report", label: "Payment Wise Sales" },
                    { key: "expenses", label: "Company Expenses" },
                ].map((tab) => (
                    <li className="nav-item" role="presentation" key={tab.key}>
                        <button
                            type="button"
                            role="tab"
                            onClick={() => setActiveTab(tab.key)}
                            className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                            aria-selected={activeTab === tab.key}
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>


            {/* Content Area */}
            <div
                style={{
                    marginTop: "25px",
                    padding: "20px",
                    background: "white",
                    borderRadius: "12px",
                    boxShadow: "0 2px 10px rgba(72, 72, 72, 0.1)",
                }}
            >
                {/* DATE TAB */}
                {activeTab === "date" && (
                    <>
                        <div className="row align-items-center g-2">
                            {/* Title */}
                            <div className="col-lg-5 col-md-12">
                                <h3 className="mb-0 text-primary">
                                    Date Wise Purchases
                                    <small className="text-muted d-block">
                                        (Showing:
                                        <strong>
                                            {" "}
                                            {moment(startDate).format("DD/MMM/YYYY")} -{" "}
                                            {moment(endDate).format("DD/MMM/YYYY")}
                                        </strong>
                                        )
                                    </small>
                                </h3>
                            </div>

                            {/* Actions */}
                            <div className="col-lg-7 col-md-12">
                                <div className="d-flex flex-wrap justify-content-lg-end gap-2">

                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Start Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto"
                                            value={moment(startDate).format("YYYY-MM-DD")}
                                            onChange={(e) => setStartDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            End Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto"
                                            value={moment(endDate).format("YYYY-MM-DD")}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            max={moment().format("YYYY-MM-DD")}
                                        />
                                    </div>

                                    <button className="btn btn-primary" onClick={fetchMonthData}>
                                        Apply
                                    </button>

                                    <button
                                        className="btn btn-outline-danger"
                                        onClick={() => {
                                            setStartDate(firstDay);
                                            setEndDate(today);
                                            fetchMonthData();
                                        }}
                                    >
                                        Reset
                                    </button>
                                    <button
                                        className="btn btn-success"
                                        onClick={() => {
                                            exportTableToExcel(
                                                exportDateWise.columns,
                                                exportDateWise.processedRows,
                                                exportDateWise.totals,
                                                "Date_Wise_Purchases"
                                            );
                                        }}
                                    >
                                        Download Excel
                                    </button>
                                </div>
                            </div>
                        </div>

                        <DateWisePurchaseReportTable data={dateWiseData} onReady={(table) => setExportDateWise(table)} />
                    </>
                )}

                {/* MONTH TAB */}
                {activeTab === "month_purchase" && (
                    <>


                        {/* YEAR NAVIGATION */}
                        <div className="row align-items-center g-2">
                            {/* Title */}
                            <div className="col-lg-5 col-md-12">
                                <h3 className="mb-0 text-primary">
                                    Yearly Purchases
                                    <small className="text-muted d-block">
                                        (Showing Year: <strong>{selectedYear}</strong>)
                                    </small>
                                </h3>
                            </div>

                            {/* Actions */}
                            <div className="col-lg-7 col-md-12">
                                <div className="d-flex flex-wrap justify-content-lg-end align-items-center gap-2">


                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Select Year
                                        </span>

                                        <select
                                            className="form-select w-auto"
                                            value={selectedYear}
                                            onChange={(e) => setSelectedYear(Number(e.target.value))}
                                        >
                                            {Array.from(
                                                { length: currentYear - 2010 + 1 },
                                                (_, i) => {
                                                    const year = 2010 + i;
                                                    return (
                                                        <option key={year} value={year}>
                                                            {year}
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </select>
                                    </div>
                                    <button
                                        className="btn btn-success"
                                        onClick={() => {
                                            exportTableToExcel(
                                                exportDateWise.columns,
                                                exportDateWise.processedRows,
                                                exportDateWise.totals,
                                                "Month_Wise_Purchases"
                                            );
                                        }}
                                    >
                                        Download Excel
                                    </button>
                                </div>
                            </div>
                        </div>


                        <MonthWisePurchaseReportTable data={monthWiseData} onReady={(table) => setExportDateWise(table)} />
                    </>
                )}

                {activeTab === "party_purchase" && (
                    <>
                        <div className="row align-items-center g-2">
                            {/* Title */}
                            <div className="col-lg-5 col-md-12">
                                <h3 className="mb-0 text-primary">
                                    Party Wise Purchases
                                    <small className="text-muted d-block">
                                        (Showing:
                                        <strong>
                                            {" "}
                                            {moment(startDateParty).format("DD/MMM/YYYY")} -{" "}
                                            {moment(endDateParty).format("DD/MMM/YYYY")}
                                        </strong>
                                        )
                                    </small>
                                </h3>
                            </div>

                            {/* Actions */}
                            <div className="col-lg-7 col-md-12">
                                <div className="d-flex flex-wrap justify-content-lg-end gap-2">


                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Start Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto"
                                            value={moment(startDateParty).format("YYYY-MM-DD")}
                                            onChange={(e) => setStartDateParty(e.target.value)}
                                        />
                                    </div>

                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            End Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto"
                                            value={moment(endDateParty).format("YYYY-MM-DD")}
                                            onChange={(e) => setEndDateParty(e.target.value)}
                                            max={moment().format("YYYY-MM-DD")}
                                        />
                                    </div>

                                    <button className="btn btn-primary" onClick={fetchPartyData}>
                                        Apply
                                    </button>

                                    <button
                                        className="btn btn-outline-danger"
                                        onClick={() => {
                                            setStartDateParty(firstDay);
                                            setEndDateParty(today);
                                            fetchPartyData();
                                        }}
                                    >
                                        Reset
                                    </button>
                                    <button
                                        className="btn btn-success"
                                        onClick={() => {
                                            exportTableToExcel(
                                                exportDateWise.columns,
                                                exportDateWise.processedRows,
                                                exportDateWise.totals,
                                                "Party_Wise_Purchases"
                                            );
                                        }}
                                    >
                                        Download Excel
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* TABLE */}
                        <PartyWisePurchaseReportTable data={partyWiseData} onReady={(table) => setExportDateWise(table)} start_date={startDateParty} end_date={endDateParty} />
                    </>
                )}
                {activeTab === "sales" && (
                    <>
                        <div className="row align-items-center g-2">
                            {/* Title */}
                            <div className="col-lg-5 col-md-12">
                                <h3 className="mb-0 text-primary">
                                    Date Wise Sales
                                    <small className="text-muted d-block">
                                        (Showing:
                                        <strong>
                                            {" "}
                                            {moment(startDateSales).format("DD/MMM/YYYY")} -{" "}
                                            {moment(endDateSales).format("DD/MMM/YYYY")}
                                        </strong>
                                        )
                                    </small>
                                </h3>
                            </div>

                            {/* Filters & Actions */}
                            <div className="col-lg-7 col-md-12">
                                <div className="d-flex flex-wrap justify-content-lg-end align-items-end gap-2">


                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Product Type
                                        </span>
                                        <select
                                            className="form-select w-auto pt-3"
                                            onChange={(e) => setProductTypeSales(e.target.value)}
                                        >
                                            <option>All</option>
                                            <option>Existing</option>
                                            <option>Old Products</option>
                                        </select>
                                    </div>


                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Start Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto pt-3"
                                            value={moment(startDateSales).format("YYYY-MM-DD")}
                                            onChange={(e) => setStartDateSales(e.target.value)}
                                        />
                                    </div>


                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            End Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto pt-3"
                                            value={moment(endDateSales).format("YYYY-MM-DD")}
                                            onChange={(e) => setEndDateSales(e.target.value)}
                                            max={moment().format("YYYY-MM-DD")}
                                        />
                                    </div>


                                    <button className="btn btn-primary" onClick={fetchSalesData}>
                                        Apply
                                    </button>

                                    <button
                                        className="btn btn-outline-danger"
                                        onClick={() => {
                                            setStartDateSales(firstDay);
                                            setEndDateSales(today);
                                            fetchSalesData();
                                        }}
                                    >
                                        Reset
                                    </button>
                                    <button
                                        className="btn btn-success"
                                        onClick={() => {
                                            exportTableToExcel(
                                                exportDateWise.columns,
                                                exportDateWise.processedRows,
                                                exportDateWise.totals,
                                                "Date_Wise_Sales"
                                            );
                                        }}
                                    >
                                        Download Excel
                                    </button>
                                </div>
                            </div>
                        </div>


                        {/* TABLE */}
                        <DateWiseSalesReportTable data={salesWiseData} onReady={(table) => setExportDateWise(table)} />
                    </>
                )}

                {activeTab === "month_sales" && (
                    <>
                        <div className="row align-items-center g-2">
                            {/* Title */}
                            <div className="col-lg-5 col-md-12">
                                <h3 className="mb-0 text-primary">
                                    Yearly Sales
                                    <small className="text-muted d-block">
                                        (Showing Year: <strong>{selectedYear}</strong>)
                                    </small>
                                </h3>
                            </div>

                            {/* Actions */}
                            <div className="col-lg-7 col-md-12">
                                <div className="d-flex flex-wrap justify-content-lg-end align-items-end gap-2">

                                    {/* Download Excel */}


                                    {/* Product Type */}
                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Product Type
                                        </span>
                                        <select
                                            className="form-select w-auto pt-3"
                                            onChange={(e) => setProductTypeSalesMonthly(e.target.value)}
                                        >
                                            <option>All</option>
                                            <option>Existing</option>
                                            <option>Old Products</option>
                                        </select>
                                    </div>

                                    {/* Select Year */}
                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Select Year
                                        </span>
                                        <select
                                            className="form-select w-auto pt-3"
                                            value={selectedYear}
                                            onChange={(e) => setSelectedYear(Number(e.target.value))}
                                        >
                                            {Array.from({ length: currentYear - 2010 + 1 }, (_, i) => {
                                                const year = 2010 + i;
                                                return (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                    <button
                                        className="btn btn-success"
                                        onClick={() => {
                                            exportTableToExcel(
                                                exportDateWise.columns,
                                                exportDateWise.processedRows,
                                                exportDateWise.totals,
                                                "Month_Wise_Sales"
                                            );
                                        }}
                                    >
                                        Download Excel
                                    </button>

                                </div>
                            </div>
                        </div>



                        {/* TABLE */}
                        <MonthWiseSalesReportTable data={salesWiseYearlyData} onReady={(table) => setExportDateWise(table)} />
                    </>
                )}

                {activeTab === 'sales_report' && (
                    <>
                        <div className="row align-items-center g-2">
                            {/* Title */}
                            <div className="col-lg-5 col-md-12">
                                <h3 className="mb-0 text-primary">
                                    Payment Wise Sales
                                    <small className="text-muted d-block">
                                        (Showing:
                                        <strong>
                                            {" "}
                                            {moment(startDatePaymentSales).format("DD/MMM/YYYY")} -{" "}
                                            {moment(endDatePaymentSales).format("DD/MMM/YYYY")}
                                        </strong>
                                        )
                                    </small>
                                </h3>
                            </div>

                            {/* Filters & Actions */}
                            <div className="col-lg-7 col-md-12">
                                <div className="d-flex flex-wrap justify-content-lg-end align-items-end gap-2">

                                    {/* Product Type */}
                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Product Type
                                        </span>
                                        <select
                                            className="form-select w-auto pt-3"
                                            onChange={(e) => setProductTypePaymentSales(e.target.value)}
                                        >
                                            <option>All</option>
                                            <option>Existing</option>
                                            <option>Old Products</option>
                                        </select>
                                    </div>

                                    {/* Start Date */}
                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Start Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto pt-3"
                                            value={moment(startDatePaymentSales).format("YYYY-MM-DD")}
                                            onChange={(e) => setStartDatePaymentSales(e.target.value)}
                                        />
                                    </div>

                                    {/* End Date */}
                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            End Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto pt-3"
                                            value={moment(endDatePaymentSales).format("YYYY-MM-DD")}
                                            onChange={(e) => setEndDatePaymentSales(e.target.value)}
                                            max={moment().format("YYYY-MM-DD")}
                                        />
                                    </div>

                                    {/* Apply Button */}
                                    <button className="btn btn-primary" onClick={fetchPaymentWiseSalesReport}>
                                        Apply
                                    </button>

                                    {/* Reset Button */}
                                    <button
                                        className="btn btn-outline-danger"
                                        onClick={() => {
                                            setStartDateSales(firstDay);
                                            setEndDateSales(today);
                                            fetchSalesData();
                                        }}
                                    >
                                        Reset
                                    </button>
                                    <button
                                        className="btn btn-success"
                                        onClick={() => exportRef.current && exportRef.current()}
                                    >
                                        Export Excel
                                    </button>

                                </div>
                            </div>
                        </div>

                        <PaymentWiseReportTableData data={salesPaymentWiseData} summary={salesPaymentSummary} startDate={startDatePaymentSales} endDate={endDatePaymentSales} onReady={(actions) => {
                            exportRef.current = actions.exportExcel;
                        }} />
                    </>
                )}

                {activeTab === "expenses" && (
                    <>
                        <div className="row align-items-center g-2">
                            {/* Title */}
                            <div className="col-lg-5 col-md-12">
                                <h3 className="mb-0 text-primary">
                                    Company Expenses
                                    <small className="text-muted d-block">
                                        (Showing:
                                        <strong>
                                            {" "}
                                            {moment(startDateExpense).format("DD/MMM/YYYY")} -{" "}
                                            {moment(endDateExpense).format("DD/MMM/YYYY")}
                                        </strong>
                                        )
                                    </small>
                                </h3>
                            </div>

                            {/* Filters & Actions */}
                            <div className="col-lg-7 col-md-12">
                                <div className="d-flex flex-wrap justify-content-lg-end align-items-end gap-2">

                                    {/* Export Button */}


                                    {/* Start Date */}
                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            Start Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto pt-3"
                                            value={moment(startDateExpense).format("YYYY-MM-DD")}
                                            onChange={(e) => setStartDateExpense(e.target.value)}
                                        />
                                    </div>

                                    {/* End Date */}
                                    <div className="position-relative">
                                        <span className="badge bg-light text-muted position-absolute top-0 start-0 translate-middle-y px-2">
                                            End Date
                                        </span>
                                        <input
                                            type="date"
                                            className="form-control w-auto pt-3"
                                            value={moment(endDateExpense).format("YYYY-MM-DD")}
                                            onChange={(e) => setEndDateExpense(e.target.value)}
                                            max={moment().format("YYYY-MM-DD")}
                                        />
                                    </div>

                                    {/* Apply */}
                                    <button
                                        className="btn btn-primary"
                                        onClick={fetchCompanyExpenseData}
                                    >
                                        Apply
                                    </button>

                                    {/* Reset */}
                                    <button
                                        className="btn btn-outline-danger"
                                        onClick={() => {
                                            setStartDateExpense(firstDay);
                                            setEndDateExpense(today);
                                            fetchCompanyExpenseData();
                                        }}
                                    >
                                        Reset
                                    </button>
                                    <button
                                        className="btn btn-success"
                                        onClick={() => {
                                            exportTableToExcel(
                                                exportDateWise.columns,
                                                exportDateWise.processedRows,
                                                exportDateWise.totals,
                                                "Company_Expense_Report"
                                            );
                                        }}
                                    >
                                        Download Excel
                                    </button>
                                </div>
                            </div>
                        </div>


                        {/* TABLE */}
                        <CompanyExpensesReport data={companyExpenseData} onReady={(table) => setExportDateWise(table)} />
                    </>
                )}

            </div>
        </div>
    );
};

export default OtherReports;
